// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"9183":"2b686ca0","9833":"fa12ab78"}[chunkId] + ".chunk.css";
};